// Light / white design tokens for v2 dashboards (Power BI Light style)
export const theme = {
  // Page canvas — soft white with very subtle blue tint
  pageBg: 'radial-gradient(1200px 600px at 10% -10%, #e7efff 0%, transparent 60%), radial-gradient(1000px 500px at 100% 0%, #eef3ff 0%, transparent 55%), linear-gradient(180deg, #f6f9fe 0%, #eef3fb 100%)',

  // Card surface
  glass: '#ffffff',
  glassStrong: '#ffffff',
  glassBorder: '1px solid #e3e8f0',
  glassBorderStrong: '1px solid #c7d1e0',
  blur: 'none',
  cardShadow: '0 2px 10px rgba(20, 40, 80, 0.06), 0 1px 2px rgba(20,40,80,0.04)',
  cardShadowHover: '0 12px 28px rgba(20, 40, 80, 0.12), 0 2px 6px rgba(20,40,80,0.06)',

  // Text
  textPrimary: '#1a2238',
  textSecondary: '#56627a',
  textMuted: '#8a96b0',

  // Accents
  accents: {
    blue:   '#2563eb',
    cyan:   '#0891b2',
    green:  '#16a34a',
    purple: '#7c3aed',
    amber:  '#d97706',
    red:    '#dc2626',
    pink:   '#db2777',
    brown:  '#a16207',
    indigo: '#4338ca',
  },

  // Semantic palette — single source of truth for KPI cards, charts, legends
  palette: {
    occupied:  '#2563eb', // blue   — Physical Occupied
    committed: '#f59e0b', // amber  — Commitment Hold
    future:    '#94a3b8', // grey   — Future Expansion (rendered with dashed/striped fill)
    blocked:   '#ef4444', // red    — Blocked
    sellable:  '#10b981', // green  — Free to Sell Now
    neutral:   '#4338ca', // indigo — Totals (Locations / Capacity)
  },
  // SVG pattern id for the dashed "future" fill — defined once in OperationsDashboard
  futurePatternId: 'future-stripes',

  panelBg: '#f5f8fd',
  rowBorder: '#eef2f8',

  radius: 14,

  // Typography — Inter is loaded via index.html
  fontFamily: '"Inter", -apple-system, "Segoe UI", system-ui, sans-serif',
  fontMono: '"JetBrains Mono", "SF Mono", Menlo, monospace',
};

// Always show the EXACT pallet/bin count — no K/M abbreviation.
// Uses the user's locale grouping (e.g. 138,612).
export const fmtNum = (v: number | string): string => {
  if (typeof v === 'string') return v;
  if (!Number.isFinite(v)) return '0';
  return Math.round(v).toLocaleString();
};
